import { useTranslation } from "react-i18next";

const AboutCreatePageHeader = () => {
  const { t } = useTranslation();
  return (
    <div className="flex-1 flex items-center justify-between w-full">
      <h1 className="lg:text-lg">{t("titles.dashboard.about.create")}</h1>
    </div>
  );
};

export default AboutCreatePageHeader;
